<template>
    <div class="news-detail">
        <banner :config="bannerConfig"></banner>
        <div class="content">
            <h1 class="title" v-html="textParse2(data.title)"></h1>
            <div class="time" v-if="data.sendTime">{{ data.sendTime.split(' ')[0] }}</div>
            <div class="digest" v-if="data.digest" v-html="textParse2(data.digest)"></div>
            <div class="wrap" v-html="data.content"></div>
        </div>
    </div>
</template>

<script setup>
import banner from '~/components/mobile/banner';
import { useI18n } from 'vue-i18n';
import { textParse2 } from '~/assets/js/utils';

const props = defineProps({
    data: {
        type: Object,
        default: () => ({})
    }
})

const { t } = useI18n();

const bannerConfig = {
    bannerType: 4,
    zhTitle: '最新资讯',
    enTitle: 'Latest News'
};
</script>

<style lang="scss" scoped>
.news-detail {
    width: 100%;
    display: flex;
    flex-direction: column;

    .content {
        width: 100%;
        margin: 78px auto 0;

        .title {
            font-weight: bold;
            font-size: 20px;
            color: #000000;
            line-height: 1.6;
            text-align: center;
            max-width: 260px;
            margin: 0 auto 20px;
        }

        .time {
            font-weight: 400;
            font-size: 14px;
            color: #000000;
            text-align: center;
            margin-bottom: 20px;
        }

        .digest {
            width: 335px;
            padding: 20px;
            box-sizing: border-box;
            font-weight: 400;
            font-size: 14px;
            color: #222222;
            line-height: 24px;
            margin: 0 auto;
            border-radius: 10px;
            border: 1px dashed #A6D6C9;
        }

        .wrap {
            margin-top: 55px;
            padding: 0 15px 60px;
            box-sizing: border-box;

            :deep() {
                img {
                    max-width: 100%;
                    object-fit: contain;
                }
            }
        }
    }
}
</style>